
import { Component, Prop, Vue } from 'vue-property-decorator'

import { LayOutInterface } from '@/interfaces/LayOutInterface'
import MensagemForm from '@/includes/auxForms/MensagemForm.vue'
import Loading from '@/includes/auxForms/Loading.vue'
import ErroWs from '@/includes/auxForms/ErroWs.vue'

import Utils from '@/utils/Utils'
import { ClsCrudVue } from '@/components/crud/ClsCrudVue'
import ClsState from '@/utils/ClsState'
import ClsLogin from './ClsLogin'
import { emDESENVOLVIMENTO, VERSAO_SISTEMA } from '../../includes/config/setupDesenvolvimento'
import { respostaPadraoInterface } from '../../interfaces/backend/padrao.interfaces'

@Component( {
  components: {
    MensagemForm,
    Loading,
    ErroWs,
  },
} )
export default class Logar extends Vue {

  private clsCrudVue: ClsCrudVue = new ClsCrudVue( this )

  private clsState: ClsState = new ClsState()
  private clsLogin: ClsLogin = new ClsLogin( this )

  private permanecerConectado: boolean = true

  private layout: LayOutInterface = this.clsCrudVue.layOutInicial

  private layoutLocal = {
    exibirForm: false,
    exibirSenha: false
  }

  private model = {
    login: '',
    senha: '',
  }

  private emDesenvolvimento = emDESENVOLVIMENTO

  private versao: string = VERSAO_SISTEMA

  private mounted (): void {

    this.layoutLocal.exibirForm = false

    this.clsLogin
      .logarPorToken()
      .then( ( resultLogarPorToken: respostaPadraoInterface ) => {
        if ( !resultLogarPorToken.ok ) {

          if ( this.emDesenvolvimento ) {

            this.model.login = 'zanatta'
            this.model.senha = 'Teste123'
            // this.model.login = 'dp'
            // this.model.senha = 'Cssjd2019'
          }

          this.layoutLocal.exibirForm = true

        } else {

          this.clsState.saveTokenToLocalStorage()

          this.redirAposLogin()

        }
      } )
  }

  private btLogar (): void {

    this.clsLogin
      .logar( this.model.login.trim(), this.model.senha.trim() )
      .then( ( resultLogar: respostaPadraoInterface ) => {
        if ( !resultLogar.ok ) {
          this.layout.exibirLoading = false
          this.layout.mensagem = resultLogar.mensagem
          this.layout.exibirMensagem = true
        } else {
          if ( this.permanecerConectado ) {
            this.clsState.saveTokenToLocalStorage()
          } else {
            this.clsState.resetTokenFromLocalStorage()
          }

          this.redirAposLogin()

        }
      } )
  }

  private redirAposLogin () {
    //TODO - Redirecionamento Inicial
    if ( this.emDesenvolvimento ) {
      // this.$router.push( '/ImportarPlanoSaude' )
      // this.$router.push( '/CrudUsuarios' )
      // this.$router.push( '/Downloads' )
      // this.$router.push( '/DownloadsPlanoSaude' )
      // this.$router.push( '/RelCriticasPlanoSaude' )
      // this.$router.push( '/Home' )
      // this.$router.push( '/Jacare' )
      // this.$router.push( '/Downloads' )
      this.$router.push( '/MenuPrincipal' )
    } else {
      this.$router.push( '/MenuPrincipal' )
    }
  }

  private fullScreen (): void {
    Utils.toggleFullScreen()
  }
}
